import { Component } from '@angular/core';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html'
})
export class PartnersComponent {
  partners = [
    { name: 'Everett Collection', logo: 'assets/images/EClogo.jpg' },
    { name: 'Tetra Images', logo: 'assets/images/tetralogoandname.jpg' },
    { name: 'Universal Images Group', logo: 'assets/images/UIGlogo.jpg' },
  ];
}
